export default __webpack_public_path__ + "static/media/t10.359c38ba.jpg";